<template>
    <div class="map-search-filter">
        <table-search @changeWord="setFilterWord" :setDefault="isDefault"></table-search>
        <rent-select :class="{active: address.county.active}" :key="componentKey+'a'" class="select-scroll" refName="county" :selectMsg="address.county.msg" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="address.county.state">
            <ul>
                <li v-for="(county, index) in countyResult" :key="index" :data-id="index" :data-name="county">
                    {{county}}
                </li>
            </ul>
        </rent-select>
        <rent-select :class="{active: address.district.active}" :key="componentKey+'b'" class="select-scroll" refName="district" :selectMsg="address.district.msg" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="address.district.state">
            <ul>
                <li v-for="(district, index) in districtsResult" :key="index" :data-id="district.districtCid" :data-name="district.districtName">
                    {{district.districtName}}
                </li>
            </ul>
        </rent-select>
        <rent-select-group class="select-scroll" refName="district" selectMsg="其他篩選" border="1px solid #d5dad8" bgColor="#fff" >
            <div class="checkbox-group">
                <div class="checkbox-group-wrap">
                    <div class="column column-1">
                        <span class="title">房屋金額</span>
                        <circle-radio  ref="houseRentAll" v-model="rentPrice" :isPropChecked="rentPrice == null ? true:false"  :val="null" checkboxMsg="全部" ></circle-radio>
                        <circle-radio  ref="houseRent" v-model="rentPrice" :isPropChecked="rentPrice == 1 ? true:false"  :val="1" checkboxMsg="5,000以下" ></circle-radio>
                        <circle-radio  ref="houseRent" v-model="rentPrice" :isPropChecked="rentPrice == 2 ? true:false"  :val="2" checkboxMsg="5,000 - 10,000" ></circle-radio>
                        <circle-radio  ref="houseRent" v-model="rentPrice" :isPropChecked="rentPrice == 3 ? true:false"  :val="3" checkboxMsg="10,000 - 20,000" ></circle-radio>
                        <circle-radio  ref="houseRent" v-model="rentPrice" :isPropChecked="rentPrice == 4 ? true:false"  :val="4" checkboxMsg="20,000 - 30,000" ></circle-radio>
                        <circle-radio  ref="houseRent" v-model="rentPrice" :isPropChecked="rentPrice == 5 ? true:false"  :val="5" checkboxMsg="30,000 以上" ></circle-radio>
                    </div>
                    <div class="column column-2">
                        <span class="title">出租類型</span>
                        <circle-radio  ref="houseTypeAll" v-model="filterQuery.houseType" :isPropChecked="filterQuery.houseType == null ? true:false"  :val="null" checkboxMsg="全部" ></circle-radio>
                        <circle-radio  ref="houseType" v-model="filterQuery.houseType" :isPropChecked="filterQuery.houseType == 1 ? true:false"  :val="1" checkboxMsg="整層住家" ></circle-radio>
                        <circle-radio  ref="houseType" v-model="filterQuery.houseType" :isPropChecked="filterQuery.houseType == 2 ? true:false"  :val="2" checkboxMsg="獨立套房" ></circle-radio>
                        <circle-radio  ref="houseType" v-model="filterQuery.houseType" :isPropChecked="filterQuery.houseType == 3 ? true:false"  :val="3" checkboxMsg="分租雅房" ></circle-radio>
                    </div>
                    <div class="column column-3">
                        <span class="title">房屋類型</span>
                        <circle-radio  ref="buildingTypeAll" v-model="filterQuery.buildingType" :isPropChecked="filterQuery.buildingType == null ? true:false"  :val="null" checkboxMsg="全部" ></circle-radio>
                        <circle-radio  ref="buildingType" v-model="filterQuery.buildingType" :isPropChecked="filterQuery.buildingType == 1 ? true:false"  :val="1" checkboxMsg="公寓" ></circle-radio>
                        <circle-radio  ref="buildingType" v-model="filterQuery.buildingType" :isPropChecked="filterQuery.buildingType == 2 ? true:false"  :val="2" checkboxMsg="電梯大樓" ></circle-radio>
                        <circle-radio  ref="buildingType" v-model="filterQuery.buildingType" :isPropChecked="filterQuery.buildingType == 3 ? true:false"  :val="3" checkboxMsg="透天厝" ></circle-radio>
                        <circle-radio  ref="buildingType" v-model="filterQuery.buildingType" :isPropChecked="filterQuery.buildingType == 4 ? true:false"  :val="4" checkboxMsg="別墅" ></circle-radio>
                    </div>
                    <div class="column column-4">
                        <span class="title">委託</span>
                        <circle-radio  ref="taskAll" v-model="filterQuery.task" :isPropChecked="filterQuery.task == null ? true:false"  :val="null" checkboxMsg="全部" ></circle-radio>
                        <circle-radio  ref="task" v-model="filterQuery.task" :isPropChecked="filterQuery.task == 0 ? true:false"  :val="0" checkboxMsg="有新增" ></circle-radio>
                        <circle-radio  ref="task" v-model="filterQuery.task" :isPropChecked="filterQuery.task == 1 ? true:false"  :val="1" checkboxMsg="無新增" ></circle-radio>
                    </div>
                    <div class="column column-5">
                        <span class="title">房屋資料</span>
                        <circle-radio  ref="statusAll" v-model="filterQuery.status" :isPropChecked="filterQuery.status == null ? true:false"  :val="null" checkboxMsg="全部" ></circle-radio>
                        <circle-radio  ref="status" v-model="filterQuery.status" :isPropChecked="filterQuery.status == 1 ? true:false"  :val="1" checkboxMsg="未完善" ></circle-radio>
                        <circle-radio  ref="status" v-model="filterQuery.status" :isPropChecked="filterQuery.status == 2 ? true:false"  :val="2" checkboxMsg="完善" ></circle-radio>
                    </div>
                </div>
            </div>
        </rent-select-group>
        <span v-show="!filterIsDefault" @click="clear" class="clear">
            回到預設
        </span>
    </div>
</template>
<script>
import TableSearch from '@/components/widge/TableSearch.vue';
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import RentSelectGroup from '@/components/widge/RentSelectGroup.vue';
import CircleRadio from '@/components/widge/CircleRadio.vue';

import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            componentKey: 0,
            filterWord: '',
            filterEmpty: false,
            isDefault: false,
            // filterQuery: {
            //     county: '',
            //     countyId: '',
            //     district: '',
            //     rent: [0, 100000],
            //     houseType: null,
            //     buildingType: null,
            //     task: null,
            //     status: null,
            // },
            address: {
                county: {
                    state: false,
                    msg: '所有縣市',
                    active: false
                },
                district: {
                    state: false,
                    msg: '所有區域',
                    active: false
                }
            },
            radioStatus: {
                houseRent: {
                    isDefault: true
                },
                houseType: {
                    isDefault: true
                }
            },
            rentPrice: null,
        }
    },
    watch: {
        filterQuery: {
            handler: function (newValue, oldValue) {
                // console.log(newValue.countyId)
                // console.log(oldValue.countyId)

                if(newValue.county){
                    this.componentKey += 1
                    this.address.county.msg = newValue.county
                    this.address.county.active = true
                    this.setDistrict(newValue.county)
                }else{
                    this.address.county.msg = '所有縣市'
                    this.address.county.active = false
                }
                if(newValue.district){
                    this.componentKey += 1
                    this.address.district.msg = newValue.district
                    this.address.district.active = true

                }else{
                    this.address.district.active = false
                    this.address.district.msg = '所有區域'
                }
                this.$store.dispatch('setBizHouseMgtFilterQuery', newValue)
            },
            deep: true
        },
        filterWord: function (val) {
            this.$store.dispatch('setBizHouseMgtFilterWord', val)
        },
        rentPrice: function (val) {
            if( val == null ){
                this.filterQuery.rent = [0 ,100000]
            }else if( val == 1 ){
                this.filterQuery.rent = [0 ,5000]
            }else if( val == 2 ){
                this.filterQuery.rent = [5000 ,10000]
            }else if( val == 3 ){
                this.filterQuery.rent = [10000 ,20000]
            }else if( val == 4 ){
                this.filterQuery.rent = [20000 ,30000]
            }else if( val == 5 ){
                this.filterQuery.rent = [30000 ,100000]
            }
        }
    },
    methods:{
        clear: function () {
            this.address.county.state = true
            this.address.district.state = true
            this.$store.commit('bizHouseManagement/set_filter_default')
            this.$store.commit('bizHouseManagement/set_cluster_id', [])
        },
        getSelectId: function (value) {
            this.isDefault = false
            let targetId = parseInt(event.target.dataset.id)

            if( value.ref == 'county' ){
                this.$store.commit('bizHouseManagement/set_cluster_id', [])
                this.address.district.state = true
                this.filterQuery.county = value.name
                this.filterQuery.countyId = targetId+1
                this.filterQuery.district = null

                this.$store.dispatch('getDistrict',(targetId+1))

            }else if( value.ref == 'district' ){
                this.$store.commit('bizHouseManagement/set_cluster_id', [])
                this.address.district.state = false
                this.filterQuery.district = value.name
            }
        },
        setFilterWord: function (value) {
            this.isDefault = false
            this.filterWord = value
        },
        setFilterDefault: function (value) {
            this.isDefault = true
            this.filterWord = ''
            this.contractState = ''
        },
        setDistrict: function (value) {
            this.countyResult.map( (county, index) => {
                if(county == value){
                    this.$store.dispatch('getDistrict',(index+1))
                }
            })
        }
    },
    computed: {
        ...mapGetters({
            countyResult: 'COUNTY_RESULT',
            districtsResult: 'DISTRICTS_RESULT',
            filterQuery: 'GET_BIZ_HOUSE_MGT_FILTER_QUERY',
            filterTotal: 'GET_BIZ_HOUSE_MGT_FILTER_RESULT_TOTAL',
            filterCountyIsEmpty: 'GET_BIZ_HOUSE_MGT_FILTER_COUNTY_IS_EMPTY',
            filterDistrictIsEmpty: 'GET_BIZ_HOUSE_MGT_FILTER_DISTRICT_IS_EMPTY',
            filterHouseTypeIsEmpty: 'GET_BIZ_HOUSE_MGT_HOUSE_TYPE_IS_EMPTY',
            filterBuildingTypeIsEmpty: 'GET_BIZ_HOUSE_MGT_BUILDING_TYPE_IS_EMPTY',
            filterTaskIsEmpty: 'GET_BIZ_HOUSE_MGT_TASK_IS_EMPTY',
            filterIsDefault: 'GET_BIZ_HOUSE_MGT_FILTER_DEFAULT'
        })
    },
    components: {
        RentSelect,
        RentSelectGroup,
        TableSearch,
        CircleRadio
    }
}
</script>
<style lang="scss" scoped>
    .map-search-filter{
        display: flex;
        align-items: center;
        width: 1074px;
        height: 84px;
        padding: 0 24px;
        box-shadow: 0 1px 0 0 #f0f0f0;
        background-color: #ffffff;
        >div{
            margin-right: 24px;
        }
        .biz-rent-select{
            width: 110px;
        }
        .biz-rent-select.active span {
            color: #676362 !important;
        }
        .clear{
            position: absolute;
            right: 38px;
            cursor: pointer;
            font-size: 12px;
            color: #ff9275;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseMgt/houseMgt/mapMode/MapSearchFilter.vue